import {ButtonProps} from "@FRAMEWORK/ui/types/d";
import styled, {css} from "styled-components";

interface IProps extends ButtonProps {
	types: "plus" | "minus";
	// disabled?: boolean;
}

const StyledButton = styled.button<IProps>`
	position: relative;
	width: 45px;
	height: 45px;
	border: 1px solid var(--bl-color);
	background-color: #fff;
	color: var(--emp-color);

	${props => {
		if (props.types === "plus") {
			return css`
				:before {
					position: absolute;
					top: 15px;
					left: 21px;
					display: block;
					width: 2px;
					height: 14px;
					background-color: var(--emp-color);
					content: "";
				}
				:after {
					position: absolute;
					top: 21px;
					left: 15px;
					display: block;
					width: 14px;
					height: 2px;
					background-color: var(--emp-color);
					content: "";
				}
			`;
		}
		if (props.types === "minus") {
			return css`
				:before {
					position: absolute;
					top: 21px;
					left: 15px;
					display: block;
					width: 14px;
					height: 2px;
					background-color: var(--emp-color);
					content: "";
				}
				&[type="button"]:disabled {
					background: #eee;
					color: var(--emp-color);
					cursor: unset;
				}
			`;
		}
	}}

	&[type="button"]:disabled {
		background-color: #fff;

		&:before {
			background-color: var(--line-color);
		}

		&:after {
			background-color: var(--line-color);
		}
	}
`;

const NumberButton = ({types = "minus", disabled = false, ...props}: IProps) => (
	<StyledButton type="button" disabled={disabled} types={types} {...props}></StyledButton>
);

export default NumberButton;
